module.exports = __webpack_public_path__ + "static/img/chengnuo.5c80ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom_develop/chengnuo.png
// module id = ekRI
// module chunks = 1